<main class="content">
  <form [formGroup]="form">
    <!-- CENTRO SALIDA / CENTRO ENTRADA -->
    <section class="content--section mgTop">
      <h5 class="content--section__title">{{ 'selectESCenters' | i18next }}</h5>
      <div class="content--section__centerContainer">
        <div class="content--section__centerContainer__centerItem">
          <mat-form-field class="width-standar">
            <mat-label for="class" class="loan-request--label">{{
              'centerExit' | i18next
            }}</mat-label>
            <mat-select
              name="centerExit"
              formControlName="centerExit"
              class="loan-request--select__input"
              (change)="updateInfo()"
            >
              <mat-option *ngFor="let option of centers" [value]="option.id">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="content--section__centerContainer__centerItem">
          <mat-form-field class="width-standar">
            <mat-label for="class" class="loan-request--label">{{
              'centerEntry' | i18next
            }}</mat-label>
            <mat-select
              name="centerEntry"
              formControlName="centerEntry"
              class="loan-request--select__input"
              (change)="updateInfo()"
            >
              <mat-option *ngFor="let option of centers" [value]="option.id">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </section>
    <!-- FECHA SALIDA / FECHA ENTRADA -->
    <section class="content--section mgTop">
      <h5 class="content--section__title">
        {{ 'selectDatesES' | i18next }}
      </h5>
      <div class="content--section__dates">
        <div class="content--section__dates--dateRow">
          <mat-form-field class="content--section__dateContainer">
            <mat-label>{{ 'exitDate' | i18next }}</mat-label>
            <input
              matInput
              [matDatepicker]="exitPicker"
              formControlName="exitDate"
              (dateChange)="changeDate('exitDate')"
              [min]="minDate"
              readonly
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="exitPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #exitPicker (closed)="close()"></mat-datepicker>
          </mat-form-field>
          <mat-form-field  class="content--section__hourPick">
            <mat-label>{{ 'exitHour' | i18next }}</mat-label>
            <mat-select
              formControlName="exitHour"
              (selectionChange)="changeDate('exitHour')"
              [(value)]="selectedHour"
            >
              <mat-option
                *ngFor="let hour of hoursMinutes"
                [value]="hour"
                [disabled]="
                  exitDateString === today.toDateString() && hour <= actualHour
                "
                >{{ hour }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <div class="content--section__dates--dateRow">
          <mat-form-field class="content--section__dateContainer">
            <mat-label>{{ 'entryDate' | i18next }}</mat-label>
            <input
              matInput
              [matDatepicker]="entryPicker"
              formControlName="entryDate"
              (dateChange)="changeDate('entryDate')"
              [min]="form.value.exitDate"
              readonly
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="entryPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #entryPicker (closed)="close()"></mat-datepicker>
          </mat-form-field>
          <mat-form-field  class="content--section__hourPick">
            <mat-label>{{ 'entryHour' | i18next }}</mat-label>
            <mat-select
              formControlName="entryHour"
              (selectionChange)="changeDate('entryHour')"
            >
              <mat-option
                *ngFor="let hour of hoursMinutes"
                [value]="hour"
                [disabled]="
                  exitDateString === entryDateString &&
                  hour <= form.value.exitHour
                "
                >{{ hour }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </section>

    <!-- RAZONES -->
    <section class="content--section mgTop">
      <h5 class="content--section__title">{{ 'loanReason' | i18next }}</h5>
      <div class="dpFlex">
        <div class="content--section__reasonInput">
          <mat-form-field class="width-standar">
            <mat-label class="loan-request--label" for="reason">{{
              'reason' | i18next
            }}</mat-label>
            <mat-select
              name="reason"
              id="reason"
              formControlName="reason"
              class="loan-request--select__input"
              (selectionChange)="changeReason($event.value)"
            >
              <mat-option *ngFor="let option of esReasonsKeys" [value]="option">
                {{ esReasonsEnum[option] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="content--section__textarea">
          <mat-form-field class="custom-autocomplete">
            <mat-label>{{ placeholder }}</mat-label>
            <textarea
              matInput
              name="reasonText"
              id="reasonText"
              class="loan-request--textArea"
              class="content--section__textarea--input"
              formControlName="reasonText"
              (change)="changeReasonText()"
            >
            </textarea>
          </mat-form-field>
          <div *ngIf="reasonText" class="errorReasonContainer">
            <small class="error-message">{{ placeholder }}</small>
          </div>
        </div>
      </div>
    </section>

    <!-- TIPO CONDUCTOR -->
    <section class="content--section mgTop">
      <h5 class="content--section__title">
        {{ 'loanSelectDriverTitle' | i18next }}
      </h5>
      <div class="content--section__item">
        <mat-form-field class="loan-request--column__item width-standar">
          <mat-label for="driverType" class="loan-request--label">{{
            'loanDriver' | i18next
          }}</mat-label>
          <mat-select
            #select
            name="driverType"
            id="driverType"
            class="loan-request--select__input"
            formControlName="driverType"
            (selectionChange)="changeDriverType()"
          >
            <mat-option value="INTERNAL">{{ 'intern' | i18next }}</mat-option>
            <mat-option value="EXTERNAL">{{ 'extern' | i18next }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <small class="error-message" *ngIf="driverTypeError">{{
        'selectType' | i18next
      }}</small>
    </section>

    <!-- CONDUCTOR INTERNO -->
    <form [formGroup]="driverForm">
      <section
        class="content--section mgTop"
        *ngIf="form.value.driverType === 'INTERNAL'"
      >
        <h5
          class="content--section__title"
          *ngIf="form.value.driverType === 'INTERNAL'"
        >
          {{ 'interDriverInfo' | i18next }}
        </h5>
        <div class="content--section__driverContainer">
          <div style="margin-right: 30px;">
            <mat-form-field class="width-standar">
              <mat-label>{{ 'introduceNis' | i18next }}</mat-label>
              <input
                matInput
                type="text"
                class="loan-request--select__input"
                formControlName="nis"
                (change)="updateInfoNis()"
              />
            </mat-form-field>
          </div>
          <div class="content--section__nameSearcher">
            <mat-form-field class="custom-autocomplete">
              <mat-label>{{ 'fullnameResume' | i18next }}</mat-label>
              <input
                class="loan-request--select__input"
                type="text"
                matInput
                [formControl]="searchControl"
                formControlName="fullName"
                [matAutocomplete]="auto"
                (change)="updateInfoNis()"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onOptionSelected($event, 'INTERNAL')"
              >
                <mat-option
                  *ngFor="let option of filteredOptions | async"
                  [value]="option"
                >
                  {{ option.fullName }} {{ option.id }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="content--section__driverContainer">
          <div class="nisErrorContainer" *ngIf="nisError">
            <small class="error-message">{{
              'errorWrongNis' | i18next
            }}</small>
          </div>
          <div class="nisErrorContainer" *ngIf="nisErrorLength">
            <small class="error-message">{{
              'nisErrorLength' | i18next
            }}</small>
          </div>
          <div class="nisErrorContainer" *ngIf="errorNisName">
            <small class="error-message">{{
              'errorNoNisAndNoName' | i18next
            }}</small>
          </div>
          <div class="nisErrorContainer" *ngIf="nameError">
            <small class="error-message">{{
              'nameError' | i18next
            }}</small>
          </div>
          <div class="nisErrorContainer" *ngIf="noNameError">
            <small class="error-message">{{
              'noNameError' | i18next
            }}</small>
          </div>
        </div>
      </section>
      <!-- CONDUCTOR EXTERNO -->
      <section
        class="content--section mgTop"
        *ngIf="form.value.driverType === 'EXTERNAL'"
      >
        <h5 class="content--section__title">
          {{ 'externDriverInfo' | i18next }}
        </h5>
        <div class="content--section__driverContainer">
          <div class="content--section__nameSearcherExtern">
            <mat-form-field class="custom-autocomplete">
              <mat-label>{{ 'fullnameResume' | i18next }}</mat-label>
              <input
                class="loan-request--select__input"
                type="text"
                matInput
                [formControl]="searchExternalControl"
                formControlName="fullName"
                [matAutocomplete]="auto"
                (change)="updateInfo()"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="onOptionSelected($event, 'EXTERNAL')"
              >
                <mat-option
                  *ngFor="let option of externalDrivers | async"
                  [value]="option"
                >
                  {{ option.fullName }} {{ option.id }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <button
            *ngIf="!isSelected"
            type="button"
            class="button-green"
            (click)="createExternalDriver()"
            [disabled]="isSelected"
          >
            {{ 'btnCreateDriver' | i18next | uppercase }}
          </button>
          <div class="content--section__driverContainer">
            <div class="nisErrorContainer">
              <small class="error-message" *ngIf="nameError">{{
                'nameError' | i18next
              }}</small>
            </div>
            <div class="nisErrorContainer">
              <small class="error-message" *ngIf="noNameError">{{
                'noNameError' | i18next
              }}</small>
            </div>
          </div>
          <button
            *ngIf="isSelected"
            type="button"
            class="button-green"
            (click)="modifyExternalDriver()"
            [disabled]="!isSelected"
          >
            {{ 'btnModifyDriver' | i18next }}
          </button>
        </div>
      </section>
      <section class="content--section" *ngIf="form.value.driverType !== ''">
        <div class="content--section__radio">
          <mat-checkbox
            required
            color="primary"
            type="checkbox"
            name="driverLicense"
            id="driverLicense"
            formControlName="driverLicense"
            (change)="updateInfo()"
            >{{ 'loanDriverLicense' | i18next }}</mat-checkbox
          >
        </div>
      </section>
    </form>
  </form>
</main>
